import React from 'react'
import classNames from 'classnames'
import s from './GeoentityBlockTitle.less'
import { getComponentOrClassNameByGeoentityBlockAspect } from './GeoentityBlockUtils'

const GeoentityBlockTitle = props => {
  const TitleComponent = getComponentOrClassNameByGeoentityBlockAspect(
    {
      partTitle: PartTitle,
      contentTitle: ContentTitle,
      productTitle: ProductTitle
    },
    props.data
  )

  if (!TitleComponent) return null

  return <TitleComponent {...props} />
}

const PartTitle = ({ data }) => <h2 className={classNames(s.title, s.partTitle)}>{data.title}</h2>

const ContentTitle = ({ data }) => <div className={classNames(s.title, s.contentTitle)}>{data.title}</div>

const ProductTitle = ({ data }) => <div className={classNames(s.title, s.productTitle)}>{data.title}</div>

export default GeoentityBlockTitle
